import { BatchesService } from '@festina/moneyout-general-types/moneyout/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteMoneyOutBatch = () =>
  useFestinaMutation({
    component: 'moneyOut',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: (arg: MethodParam) => method(arg),
  })
